(function () {
    'use strict';
    var controllerId = 'classeAdd';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', 'sectionMenu', '$uibModalInstance', 'indirizzi', 'anno', classeAddFn]);

    function classeAddFn($scope, datacontext, sectionMenu, $uibModalInstance, indirizzi, anno) {
        $scope.indirizzi = indirizzi;
        $scope.classe = {};
        $scope.classe.Anno = anno;        
        $scope.indirizziAggiuntivi = [];
        $scope.getIndirizziAggiuntivi = getIndirizziAggiuntivi;
        $scope.getSocieta = getSocieta;
        $scope.societa = [];

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.classe);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            if (typeof (item.IndirizzoAggiuntivoId) === 'string') {
                item.IndirizzoAggiuntivoId = 0;
            }

            return datacontext.classe_add(item).then(function (data) {
                if (!data || data.Id == null || data.Id == 0) return null;
                return data;
            });
        }

        function getIndirizziAggiuntivi(ricerca) {
            if (!$scope.classe.SocietaId)
                return null;

            $scope.classe.IndirizzoAggiuntivo = ricerca;
            return datacontext.indirizzoAggiuntivo_getAllByFilter($scope.classe.SocietaId, ricerca).then(function (data) {
                if (Array.isArray(data) && data.length > 0) {
                    $scope.indirizziAggiuntivi = data;
                    return $scope.indirizziAggiuntivi;
                }
                return null;
            });
        }
        

        // funzione che permette di visualizzare il nome della sede e non l'id
        $scope.formatLabel = function (model) {
            for (var i = 0; i < $scope.indirizziAggiuntivi.length; i++) {
                if (model === $scope.indirizziAggiuntivi[i].Id) {
                    $scope.classe.IndirizzoAggiuntivo = $scope.indirizziAggiuntivi[i].Sede;
                    return $scope.classe.IndirizzoAggiuntivo;
                }
            }
        };

        // funzione che permette di visualizzare l'[id] RagioneSociale (Comune) della societ� e non l'id
        $scope.formatLabelSocieta = function (model) {
            for (var i = 0; i < $scope.societa.length; i++) {
                if (model === $scope.societa[i].Id) {
                    $scope.classe.Societa = '[' + $scope.societa[i].Id + ']' + ' ' + $scope.societa[i].RagioneSociale + ' ' + '(' + $scope.societa[i].Comune + ')';
                    return $scope.classe.Societa;
                }
            }
        };

        function getSocieta(ricerca) {

            $scope.classe.SocietaId = ricerca;
            return datacontext.societa_getAllByFilter($scope.classe.SocietaId, ricerca).then(function (data) {
                if (Array.isArray(data) && data.length > 0) {
                    $scope.societa = data;
                    return $scope.societa;
                }
                return null;
            });
        }
    }
})();